// Holds the current event id for the admin session. v1 = single event,
// future: dropdown picker. Default seeded id = haringparty-2026.

import { useQuery } from "@tanstack/react-query";
import { listEvents } from "./api";

export const DEFAULT_EVENT_ID = "00000000-0000-4000-a000-000000000001";

export function useCurrentEvent() {
  return useQuery({
    queryKey: ["events", "current"],
    queryFn: async () => {
      const all = await listEvents();
      return all.find((e) => e.id === DEFAULT_EVENT_ID) ?? all[0] ?? null;
    },
    staleTime: 60_000,
  });
}
